import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData(
  saleAreaId,
  projectId,
  department,
  employeeId
) {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();

  let customerQueryParams = searchQueryParams;

  let searchQueryEmployeeDepartment = new URLSearchParams({
    ...searchOptions,
    // status: 0,
  }).toString();

  let searchQueryEmployeeData = new URLSearchParams({
    ...searchOptions,
    // status: 0,
  }).toString();

  if (department) {
    searchQueryEmployeeDepartment =
      searchQueryEmployeeDepartment +
      "&" +
      new URLSearchParams({ department }).toString();
  }

  if (employeeId) {
    customerQueryParams =
      customerQueryParams +
      "&" +
      new URLSearchParams({ employeeId }).toString();
  }

  // Fetch constant data concurrently
  const [
    project,
    apartment,
    customer,
    employeeDepartMent,
    paymentMethod,
    employeeData,
    saleOpeningEvent,
    booking,
  ] = await Promise.all([
    clientAPI("get", `/project?${searchQueryParams}`),
    clientAPI("get", `/apartment?${searchQueryParams}`),
    clientAPI("get", `/customer?${customerQueryParams}`),
    clientAPI("get", `/employee?${searchQueryEmployeeDepartment}`),
    clientAPI("get", `/paymentMethod?${searchQueryParams}`),
    clientAPI("get", `/employee?${searchQueryEmployeeData}`),
    clientAPI("get", `/saleOpeningEvent?${searchQueryParams}`),
    clientAPI("get", `/booking?${searchQueryParams}`),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    project: project?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    apartment: apartment?.items?.reduce(
      (acc, item) => ({
        ...acc,
        [item._id]: {
          name: item.name,
          code: item.code,
        },
      }),
      {}
    ),
    customer: customer?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    employeeDepartMent: employeeDepartMent?.items?.reduce(
      (acc, item) => ({
        ...acc,
        [item._id]: {
          fullName: item.fullName,
          code: item.code,
        },
      }),
      {}
    ),
    paymentMethod: paymentMethod?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    employeeData: employeeData?.items?.reduce(
      (acc, item) => ({
        ...acc,
        [item._id]: {
          fullName: item.fullName,
          code: item.code,
        },
      }),
      {}
    ),
    saleOpeningEvent: saleOpeningEvent?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    booking: booking?.items?.reduce(
      (acc, item) => ({
        ...acc,
        [item._id]: {
          name: item.name,
          code: item.code,
        },
      }),
      {}
    ),
  };
}

export function useCategories(
  saleAreaId,
  projectId,
  department,
  employeeId,
  shouldFetch
) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories17", saleAreaId, projectId, department, employeeId],
    queryFn: () =>
      fetchConstantData(saleAreaId, projectId, department, employeeId),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
